import Vue from 'vue';
import VueRouter from 'vue-router';
import WX  from 'weixin-js-sdk'


Vue.use(VueRouter);

// 在 import 的括号里 加注释 /* webpackChunkName: 'index' */ ，为引入的文件取别名
// 在 import 的括号里 加注释 /* webpackPrefetch: true */ ，在父 chunk 完成加载后，闲时加载
const routes = [
    {
        path:'/',
        redirect:'/home'
    },
    {
        path: '/nofound',
        name: 'nofound',
        component: () => import(/* webpackChunkName: '404' */ /* webpackPrefetch: true */ '@/pages/404.vue'),
        meta: { title: '404' }
    },
    {
        path: '/error',
        name: 'error',
        component: () => import(/* webpackChunkName: '404' */ /* webpackPrefetch: true */ '@/pages/500.vue'),
        meta: { title: 'error' }
    },
    {
        path: '/login',
        name: 'login',
        component: () => import(/* webpackChunkName: 'home' */ /* webpackPrefetch: true */ '@/pages/login/index.vue'),
        meta: { title: ' ' }
    },
    {
        path: '/logincode',
        name: 'loginCode',
        component: () => import(/* webpackChunkName: 'home' */ /* webpackPrefetch: true */ '@/pages/logincode/index.vue'),
        meta: { title: ' ' }
    },
    {
        path: '/agreement/:type',
        name: 'agreement',
        component: () => import(/* webpackChunkName: 'home' */ /* webpackPrefetch: true */ '@/pages/agreement/index.vue'),
        meta: { title: '政策协议' }
    },
    {
        path: '/companyguide',
        name: 'companyguide',
        component: () => import(/* webpackChunkName: 'home' */ /* webpackPrefetch: true */ '@/pages/companyguide/index.vue'),
        meta: { title: ' ',keepAlive: true, }
    },
    {
        path: '/companyguidenext',
        name: 'companyguidenext',
        component: () => import(/* webpackChunkName: 'home' */ /* webpackPrefetch: true */ '@/pages/companyguidenext/index.vue'),
        meta: { title: '基础信息 '}
    },
    {
        path: '/companyguidsuccess',
        name: 'companyguidsuccess',
        component: () => import(/* webpackChunkName: 'homeh' */ /* webpackPrefetch: true */ '@/pages/companyguidsuccess/index.vue'),
        meta: { title: ' ' }
    },
    {
        path: '/guidedownload',
        name: 'guidedownload',
        component: () => import(/* webpackChunkName: 'home' */ /* webpackPrefetch: true */ '@/pages/guidedownload/index.vue'),
        meta: { title: 'h5引导下载页' }
    },
    {
        path: '/home',
        name: 'home',
        component: () => import(/* webpackChunkName: 'home' */ /* webpackPrefetch: true */ '@/pages/home/'),
        meta: { title: '政策补贴宝', keepAlive: true }
    },
    {
        path: '/searchpolicy',
        name: 'searchpolicy',
        component: () => import(/* webpackChunkName: 'home' */ /* webpackPrefetch: true */ '@/pages/searchpolicy/'),
        meta: { title: '政策大厅', keepAlive: true }
    },
    {
        path: '/detail',
        name: 'detail',
        component: () => import(/* webpackChunkName: 'home' */ /* webpackPrefetch: true */ '@/pages/detail/'),
        meta: { title: '政策详情' }
    },
    {
        path: '/vip/vipjoin',
        name: 'vipJoin',
        component: () => import(/* webpackChunkName: 'vipJoin' */ /* webpackPrefetch: true */ '@/pages/vip/vipJoin.vue'),
        meta: { title: ' ' }
    },
    {
        path: '/vip/vipfree',
        name: 'vipFree',
        component: () => import(/* webpackChunkName: 'vipFree' */ /* webpackPrefetch: true */ '@/pages/vip/vipFree.vue'),
        meta: { title: '授人以鱼不如授人以渔' }
    },
    {
        path: '/vip/vipcode',
        name: 'vipCode',
        component: () => import(/* webpackChunkName: 'vipCode' */ /* webpackPrefetch: true */ '@/pages/vip/vipCode.vue'),
        meta: { title: '会员兑换码' }
    },
    {
        path: '/vip/successcode',
        name: 'successCode',
        component: () => import(/* webpackChunkName: 'successCode' */ /* webpackPrefetch: true */ '@/pages/vip/success/successCode.vue'),
        meta: { title: '会员兑换码' }
    },
    {
        path: '/vip/successfreevip',
        name: 'successfreevip',
        component: () => import(/* webpackChunkName: 'successFreeVip' */ /* webpackPrefetch: true */ '@/pages/vip/success/successFreeVip.vue'),
        meta: { title: 'VIP赠送成功' }
    },
    {
        path: '/vip/successjoinvip',
        name: 'successJoinvip',
        component: () => import(/* webpackChunkName: 'successFreeVip' */ /* webpackPrefetch: true */ '@/pages/vip/success/successJoinVip.vue'),
        meta: { title: 'VIP订购成功' }
    },
    {
        path: '/companyinfo',
        name: 'companyinfo',
        component: () => import(/* webpackChunkName: 'companyinfo' */ /* webpackPrefetch: true */ '@/pages/companyinfo/index.vue'),
        meta: { title: '完善企业资料' }
    },
    {
        path: '/member',
        name: 'member',
        component: () => import(/* webpackChunkName: 'member' */ /* webpackPrefetch: true */ '@/pages/member'),
        meta: { title: '会员中心', scrollTop: true }
    },
    {
        path: '/member/coupon',
        name: 'coupon',
        component: () => import(/* webpackChunkName: 'coupon' */ /* webpackPrefetch: true */ '@/pages/member/coupon.vue'),
        meta: { title: '我的优惠券' }
    },
    {
        path: '/member/collection',
        name: 'collection',
        component: () => import(/* webpackChunkName: 'coupon' */ /* webpackPrefetch: true */ '@/pages/member/collection.vue'),
        meta: { title: '我的收藏', keepAlive: true }
    },
    {
        path: '/member/history',
        name: 'history',
        component: () => import(/* webpackChunkName: 'hisotry' */ /* webpackPrefetch: true */ '@/pages/member/history.vue'),
        meta: { title: '浏览历史', scrollTop: true }
    },
    {
        path: '/member/person',
        name: 'person',
        component: () => import(/* webpackChunkName: 'coupon' */ /* webpackPrefetch: true */ '@/pages/member/person.vue'),
        meta: { title: '个人资料' }
    },
    {
        path: '/member/feedback',
        name: 'feedback',
        component: () => import(/* webpackChunkName: 'feedback' */ /* webpackPrefetch: true */ '@/pages/member/feedback.vue'),
        meta: { title: '意见反馈' }
    },
    {
        path: '/member/mysubscribe',
        name: 'mysubscribe',
        component: () => import(/* webpackChunkName: 'feedback' */ /* webpackPrefetch: true */ '@/pages/member/mysubscribe.vue'),
        meta: { title: '我的订阅' }
    },
    {
        path: '/member/subscribelist',
        name: 'subscribelist',
        component: () => import(/* webpackChunkName: 'feedback' */ /* webpackPrefetch: true */ '@/pages/member/subscribelist.vue'),
        meta: { title: '我的订阅列表' }
    },
    {
        path: '/member/subscribedetail',
        name: 'subscribedetail',
        component: () => import(/* webpackChunkName: 'feedback' */ /* webpackPrefetch: true */ '@/pages/member/subscribedetail.vue'),
        meta: { title: '订阅列表详情' }
    },
    {
        path: '/member/mysubscribeadd',
        name: 'mysubscribeadd',
        component: () => import(/* webpackChunkName: 'feedback' */ /* webpackPrefetch: true */ '@/pages/member/mysubscribeadd.vue'),
        meta: { title: '' }
    },
    {
        path: '/member/message',
        name: 'message',
        component: () => import(/* webpackChunkName: 'message' */ /* webpackPrefetch: true */ '@/pages/member/message.vue'),
        meta: { title: '我的消息'}
    },
    {
        path: '/myvip',
        name: 'myvip',
        component: () => import(/* webpackChunkName: 'myVip' */ /* webpackPrefetch: true */ '@/pages/vip/myVip.vue'),
        meta: { title: '我的会员权益' }
    },
    {
        path: '/contract',
        name: 'contract',
        component: () => import(/* webpackChunkName: 'contract' */ /* webpackPrefetch: true */ '@/pages/vip/contract.vue'),
        meta: { title: '用户协议' }
    },
    {
        path: '/evaluationreport',
        name: 'evaluationreport',
        component: () => import(/* webpackChunkName: 'contract' */ /* webpackPrefetch: true */ '@/pages/home/evaluationreport.vue'),
        meta: { title: '企业综合评测报告' }
    },
    {
        path: '/specialposter',
        name: 'specialposter',
        component: () => import(/* webpackChunkName: 'contract' */ /* webpackPrefetch: true */ '@/pages/specialposter/index.vue'),
        meta: { title: '政策补贴宝' }
    },
    {
        path: '/specialposternext',
        name: 'specialposternext',
        component: () => import(/* webpackChunkName: 'contract' */ /* webpackPrefetch: true */ '@/pages/specialposternext/index.vue'),
        meta: { title: '基础评估-政策补贴宝', keepAlive: true }
    },
    {
        path: '/specialposterlast',
        name: 'specialposterlast',
        component: () => import(/* webpackChunkName: 'contract' */ /* webpackPrefetch: true */ '@/pages/specialposterlast/index.vue'),
        meta: { title: '资金匹配-政策补贴宝' }
    },
    {
        path: '/specialpostershare',
        name: 'specialpostershare',
        component: () => import(/* webpackChunkName: 'contract' */ /* webpackPrefetch: true */ '@/pages/specialpostershare/index.vue'),
        meta: { title: '推荐给好友' }
    },
    {
        path: '/forbidpage',
        name: 'forbidpage',
        component: () => import(/* webpackChunkName: 'login' */ /* webpackPrefetch: true */ '@/pages/forbidpage/index.vue'),
        meta: { title: ' ' }
    },
    {
        path: '/activityguidepage',
        name: 'activityguidepage',
        component: () => import(/* webpackChunkName: 'login' */ /* webpackPrefetch: true */ '@/pages/activityguidepage/index.vue'),
        meta: { title: ' ' }
    },
    {
        path: '/vipsign',
        name: 'vipsign',
        component: () => import(/* webpackChunkName: 'login' */ /* webpackPrefetch: true */ '@/pages/member/vipsign.vue'),
        meta: { title: 'VIP卡签名' }
    },
    {
        path: '/vipsignsuccess',
        name: 'vipsignsuccess',
        component: () => import(/* webpackChunkName: 'login' */ /* webpackPrefetch: true */ '@/pages/member/vipsignsuccess.vue'),
        meta: { title: ' ' }
    }

];

const vueRouter = new VueRouter({
    routes,
    mode: 'history',
    scrollBehavior (to, from, savedPosition) {
        // keep-alive 返回缓存页面后记录浏览位置
        if (savedPosition && to.meta.keepAlive) {
            return savedPosition;
        }
        // 异步滚动操作
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve({ x: 0, y: 1 });
            }, 0);
        })
    }
});

const originalPush = VueRouter.prototype.push
   VueRouter.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}

vueRouter.beforeEach(async (to, from, next) => {
    next();
});
vueRouter.afterEach(route => {
    // 从路由的元信息中获取 title 属性
    if (route.meta.title) {
    if(route.path==='/agreement/service'){
        document.title='政策补贴宝服务协议'
    }else if(route.path==='/agreement/privacy'){
        document.title='隐私政策'
    }else if(route.path==='/agreement/laobanyun'){
        document.title='天九老板云用户协议'
    }
    else{
        document.title = route.meta.title;
    }
    // 和小程序的通信
    WX.miniProgram.postMessage({ data: {name: route.meta.title} })

      // 如果是 iOS 设备，则使用如下 hack 的写法实现页面标题的更新
      /* if (navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
        const hackIframe = document.createElement('iframe');
        hackIframe.style.display = 'none';
        hackIframe.src = '/static/html/fixIosTitle.html?r=' + Math.random();
        document.body.appendChild(hackIframe);
        setTimeout(() => {
          document.body.removeChild(hackIframe)
        }, 300)
      } */
    }
  });
  vueRouter.onError((error)=>{
    const pattern = /Loading Chunk (\d) + failed/g;
    const isChunkLoadFailed = error.message.match(pattern);
    const targetPath = vueRouter.history.pendding.fullPath;
    if(isChunkLoadFailed){
      vueRouter.replace(targetPath)
    }
  })

export default vueRouter;

